import { integerFormatter, dateFormatter } from "../../gridFormatters";

export const backupPoolTrends = [
	{
      "field": "device_type_code",
      "headerName": "Device Type Code",
      "enableRowGroup": true,
    },
	{
      "field": "device_name",
      "headerName": "Device Name",
      "enableRowGroup": true,
    },
	{
        "field": "pool_name",
        "headerName": "Backup Pool Name",
        "enableRowGroup": true,
        "filter": "agSetColumnFilter",
    },
    {
		"field": "collection_date",
		"headerName": "Collection Date",
		"filter": "agDateColumnFilter",
		"cellRenderer": dateFormatter
	},
	{
		"field": "pool_free",
		"headerName": "Pool Free",
		"filter": "agNumberColumnFilter",
		"cellRenderer": integerFormatter,
		"aggFunc": "sum",
      	"type": "numericColumn",
	},
	{
		"field": "pool_used",
		"headerName": "Pool Used",
		"filter": "agNumberColumnFilter",
		"cellRenderer": integerFormatter,
		"type": "numericColumn",
		"aggFunc": "sum"
	},
	{
		"field": "pool_total",
		"headerName": "Pool Usable",
		"filter": "agNumberColumnFilter",
		"cellRenderer": integerFormatter,
      	"type": "numericColumn",
		"aggFunc": "sum"
	},
];